import React from 'react';

interface HorizontalBarChartProps {
  data: {
    label: string;
    value: number;
    color?: string;
  }[];
  showValues?: boolean;
}

const HorizontalBarChart: React.FC<HorizontalBarChartProps> = ({ 
  data, 
  showValues = true 
}) => {
  return (
    <div className="space-y-2 w-full">
      {data.map((item, index) => (
        <div key={index} className="w-full">
          <div className="flex justify-between mb-1 text-xs font-medium">
            <span className="text-gray-700">{item.label}</span>
            {showValues && <span className="text-gray-700">{item.value}%</span>}
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2.5">
            <div 
              className={`h-2.5 rounded-full ${item.color || 'bg-blue-600'} transition-all duration-500 ease-in-out`}
              data-width={`${Math.min(100, Math.max(0, item.value))}`}
              ref={(el) => {
                if (el) {
                  el.style.width = `${Math.min(100, Math.max(0, item.value))}%`;
                }
              }}
            ></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default HorizontalBarChart;
